export const LOCALES = ['en', 'hy', 'ru'];

export const HEADER_COLLAPSIBLE_MAX_WIDTH = 1280;
export const HEADER_BANNER_MARQUEE_MAX_WIDTH = 767;
export const HEADER_BANNER_READY_EVENT = 'header-banner-ready';
